import { ComposeViewState } from 'owa-mail-compose-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setSetDisabled', function setSetDisabled(
    viewState: ComposeViewState,
    sendDisabled: boolean
) {
    viewState.sendDisabled = sendDisabled;
});
